
import { JobOfferEntryDto } from "../dtos/JobOfferEntryDto";
import { CompanyGeneralInformationResponseDto } from "../dtos/CompanyGeneralInformationResponseDto";
import { Utils } from "../libs/utils";
import { LocationDto } from '../dtos/LocationDto';
import { Company } from "../pages/PublicCompany";

export class PublicCompanyPageRenderer {
    public constructor(private container: HTMLElement, private msg: string, private companyPage: Company) { }
    public checkboxFilterFullTime: HTMLInputElement;
    public checkboxFilterPartTime: HTMLInputElement;
    public checkboxFilterApprentice: HTMLInputElement;

    public renderJobOffer(item: JobOfferEntryDto) {

        var entryHtml = document.createElement("div");
        entryHtml.classList.add("_jobEntry");

        var entryDetailsWrapper = document.createElement("a");
        entryDetailsWrapper.classList.add('_jobEntryDetails');
        entryDetailsWrapper.setAttribute("href", "/job/" + item.permaLink + "/");
        entryDetailsWrapper.setAttribute("target", "_blank");


        var entryTitle = document.createElement("div");
        entryTitle.classList.add('_jobEntryTitle')
        var entryTitle_h3 = document.createElement("h3");
        entryTitle_h3.innerHTML = item.title;
        entryTitle.appendChild(entryTitle_h3);

        var jobIcon = document.createElement("div");
        jobIcon.classList.add('_titleImage', 'jc-icon', 'jc-cat-icon', 'sizeResponsive', item.jobCategoryIcon);

        var jobCategory = document.createElement("div");
        jobCategory.classList.add("_jobAdress");
        jobCategory.innerHTML = LocationDto.getAddressString(item.location);



        entryHtml.appendChild(jobIcon);
        entryDetailsWrapper.appendChild(entryTitle);
        entryDetailsWrapper.appendChild(jobCategory);
        entryHtml.appendChild(entryDetailsWrapper);
        this.container.appendChild(entryHtml);
    }


    public renderError() {
        var entryHtml = document.createElement("div");
        var errorHtml = document.createElement("div");
        errorHtml.innerHTML = this.msg;
        errorHtml.classList.add('_entryErrorText')
        entryHtml.appendChild(errorHtml);
        this.container.appendChild(entryHtml);
    }

    public renderGeneralInfo(responseDto: CompanyGeneralInformationResponseDto) {
        var jobOffersHeading = document.getElementById("jobOffersHeading");
        jobOffersHeading.innerHTML = "Aktuelle Jobs bei " + responseDto.displayName;
        this.renderFilter();


        var titleContainer = document.getElementById("c_titleContainer");
        titleContainer.classList.remove("hidden");

        var mainContainer = document.getElementById("c_mainContainer");
        mainContainer.classList.remove("hidden");



        var pageTitle = document.getElementById("c_title");
        var pageTitle_h1 = document.createElement("h1");
        pageTitle_h1.innerHTML = responseDto.displayName;
        pageTitle.appendChild(pageTitle_h1);



        var websiteUrl = document.getElementById("c_contactWebsiteUrl");
        if (responseDto.websiteUrl) {
            websiteUrl.setAttribute("href", responseDto.websiteUrl);
            websiteUrl.setAttribute("target", "_blank");
            var websiteUrl_p = document.createElement("p");
            websiteUrl_p.innerHTML = responseDto.websiteUrl;
            websiteUrl.appendChild(websiteUrl_p);
        } else {
            this.renderNoInformation(websiteUrl);
        }



        var contactPartner = document.getElementById("c_contactPartner");
        if (responseDto.companyBossFirstName || responseDto.companyBossLastName) {
            var contactPartner_p = document.createElement("p");
            contactPartner_p.innerHTML = responseDto.companyBossFirstName + " " + responseDto.companyBossLastName;
            contactPartner.appendChild(contactPartner_p);
        } else {
            this.renderNoInformation(contactPartner);
        }

        var contactAdress = document.getElementById("c_contactAdress");
        if (responseDto.companyLocation) {
            contactAdress.setAttribute("href", Utils.getLinkToGoogleMap(responseDto.companyLocation));
            contactAdress.setAttribute("target", "_blank");
            var contactAdress_p = document.createElement("p");
            contactAdress_p.innerHTML = LocationDto.getAddressString(responseDto.companyLocation);

            contactAdress.appendChild(contactAdress_p);
        } else {
            this.renderNoInformation(contactAdress);
        }

        var contactPhone = document.getElementById("c_contactPhone");
        if (responseDto.companyPhoneNumber) {
            var contactPhone_p = document.createElement("p");
            contactPhone_p.innerHTML = responseDto.companyPhoneNumber;
            contactPhone.appendChild(contactPhone_p);
        } else {
            this.renderNoInformation(contactPhone);
        }

        var contactImageContainer = document.getElementById("c_contactImageContainer");
        if (responseDto.companyImage) {
            var image = document.createElement("img");
            image.setAttribute("src", "data:image/png;base64," + responseDto.companyImage);
            contactImageContainer.appendChild(image);
        }


        var descriptionContainer = document.getElementById("c_descriptionContainer");
        if (responseDto.companyDescription) {
            var descriptionContainer_h2 = document.createElement("h2");
            descriptionContainer_h2.innerHTML = "Über " + responseDto.displayName;
            descriptionContainer.appendChild(descriptionContainer_h2)

            var descriptionContainer_div = document.createElement("div");
            descriptionContainer_div.innerHTML = responseDto.companyDescription;
            descriptionContainer.appendChild(descriptionContainer_div);
        }

        var videoContainer = document.getElementById("c_videoContainer");
        if (typeof responseDto.videoEmbedUrl !== "undefined") {
            videoContainer.innerHTML = responseDto.videoEmbedUrl;
        } else {
            videoContainer.classList.add("hidden");
        }




        /*var mapContainer = document.getElementById("c_mapContainer");
        if (responseDto.companyLocation) {
            var map = document.createElement("iframe");
            map.setAttribute("frameborder", "0");
            map.setAttribute("style", "border:0");

            map.setAttribute("src", Utils.getGoogleMap(responseDto.companyLocation));
            map.setAttribute("allowfullscreen", "");
            mapContainer.appendChild(map);
        }
        Disabled because customer doesnt wants it now
        
        */
    }

    private renderFilter() {
        var filterContainer = document.getElementById('filterContainer');
        var filterTitle = document.createElement('p');
        filterTitle.classList.add('filterTitle');
        filterTitle.innerText = 'Filter:';
        filterContainer.appendChild(filterTitle);

        
        this.checkboxFilterFullTime = document.createElement('input');
        var checkboxFilterFullTimeID = "checkboxFilterFullTime";
        this.checkboxFilterFullTime.type = "checkbox";
        this.checkboxFilterFullTime.name = checkboxFilterFullTimeID;
        this.checkboxFilterFullTime.id = checkboxFilterFullTimeID;
        var labelCheckboxFilterFullTime = document.createElement('label');
        labelCheckboxFilterFullTime.htmlFor = checkboxFilterFullTimeID;
        labelCheckboxFilterFullTime.appendChild(document.createTextNode('Vollzeit'));

        this.checkboxFilterPartTime = document.createElement('input');
        var checkboxFilterPartTimeID = "checkboxFilterPartTime";
        this.checkboxFilterPartTime.type = "checkbox";
        this.checkboxFilterPartTime.name = checkboxFilterPartTimeID;
        this.checkboxFilterPartTime.id = checkboxFilterPartTimeID;
        var labelCheckboxFilterPartTime = document.createElement('label');
        labelCheckboxFilterPartTime.htmlFor = checkboxFilterPartTimeID;
        labelCheckboxFilterPartTime.appendChild(document.createTextNode('Teilzeit'));

        this.checkboxFilterApprentice = document.createElement('input');
        var checkboxFilterApprenticeID = "checkboxFilterApprentice";
        this.checkboxFilterApprentice.type = "checkbox";
        this.checkboxFilterApprentice.name = checkboxFilterApprenticeID;
        this.checkboxFilterApprentice.id = checkboxFilterApprenticeID;
        var labelCheckboxFilterApprentice = document.createElement('label');
        labelCheckboxFilterApprentice.htmlFor = checkboxFilterApprenticeID;
        labelCheckboxFilterApprentice.appendChild(document.createTextNode('Ausbildung/Lehrstelle'));

        switch (this.companyPage.request.EmploymentTypeFilter) {
            case 1:
                this.checkboxFilterFullTime.checked = true;
                break;
            case 2:
                this.checkboxFilterPartTime.checked = true;
                break;
            case 4:
                this.checkboxFilterApprentice.checked = true;
                break;
            default:
                break;
        }
        this.checkboxFilterFullTime.addEventListener('click', (ev: Event) => { this.handleFilterSelection(ev, this)});
        this.checkboxFilterPartTime.addEventListener('click', (ev: Event) => { this.handleFilterSelection(ev, this)});
        this.checkboxFilterApprentice.addEventListener('click', (ev: Event) => { this.handleFilterSelection(ev, this)});
        
        filterContainer.appendChild(this.checkboxFilterFullTime);
        filterContainer.appendChild(labelCheckboxFilterFullTime);

        
        filterContainer.appendChild(this.checkboxFilterPartTime);
        filterContainer.appendChild(labelCheckboxFilterPartTime);

        filterContainer.appendChild(this.checkboxFilterApprentice);
        filterContainer.appendChild(labelCheckboxFilterApprentice);
    }

    private renderNoInformation(container) {
        var noInformation_p = document.createElement("p");
        container.classList.add("noInformation");
        noInformation_p.innerHTML = "Keine Angabe";
        container.appendChild(noInformation_p);
    }

    private handleFilterSelection(ev: Event, companyPageRenderer: PublicCompanyPageRenderer){
        const clickedCheckbox = ev.target as HTMLInputElement;
        const clickedCheckboxState = clickedCheckbox.checked;
        const allCheckboxes = clickedCheckbox.parentElement.getElementsByTagName('input');
        for(let i = 0; i < allCheckboxes.length; ++i) {
            const checkbox = allCheckboxes[i] as HTMLInputElement;
            checkbox.checked = false;
        }
        clickedCheckbox.checked = clickedCheckboxState;
        if(clickedCheckbox.id == companyPageRenderer.checkboxFilterFullTime.id && clickedCheckbox.checked == true) {
            companyPageRenderer.companyPage.request.EmploymentTypeFilter = 1;
        } else if (clickedCheckbox.id == companyPageRenderer.checkboxFilterPartTime.id && clickedCheckbox.checked == true) {
            companyPageRenderer.companyPage.request.EmploymentTypeFilter = 2;
        } else if (clickedCheckbox.id == companyPageRenderer.checkboxFilterApprentice.id && clickedCheckbox.checked == true) {
            companyPageRenderer.companyPage.request.EmploymentTypeFilter = 4;
        } else {
            companyPageRenderer.companyPage.request.EmploymentTypeFilter = 0;
        }
        companyPageRenderer.companyPage.request.pageNumber = 0;
        companyPageRenderer.companyPage.scrollHelper.reInit(companyPageRenderer.companyPage.request);
    }
}